export default __webpack_public_path__ + "static/media/10.d361de12.jpeg";